import { PatientSelectV2 } from "@api/src/types/patient";
import { MageXPatient } from "@prisma/client";

// Source tenant id is carried as-is in PatientSelectV2.c — no hardcoded
// shortcode map. Adding a new source requires no code change here.
export function mapPatientsSelectV2CToTenantId(c: string): string {
  return c;
}

export const mapPatientToPatientsSelectV2 = (
  patient: MageXPatient,
): PatientSelectV2 => {
  return {
    i: patient.id_patient,
    m: patient.id_magex,
    c: patient.tenant_id,
    n: `${patient.nom ?? ""} ${patient.prenom ?? ""}`.trim() || "Nom non spécifié",
  };
};
